var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.subDomainName)?_c('span',[_c('custom-logo')],1):_c('span',[_c('default-logo')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }